export default "__VITE_ASSET__ogq8rVGK__"